import { useEffect, useState } from "react";

//componetns
import BasicButton from "@/components/elements/global/buttons/BasicButton/BasicButton";
import Icon from "@/components/elements/icons/Icons";

//interfaces
import { IAddToButton } from "@/interfaces/buttons";
import { IconLibrary } from "@/interfaces/IconLibrary";



const AddToUndoButton = ({id, buttonText, className, isClassicCMSBlue = false, isDisabled = false, ariaLabel, onButtonClick, onUndoClick}: IAddToButton) => {
    const [showUndo, setShowUndo] = useState(false);

    const handleButtonClick = () => {
        setShowUndo(true);
        onButtonClick();
    };

    const handleUndoClick = () => {
        setShowUndo(false);
        onUndoClick();
    };

    useEffect(() => {
      setShowUndo(false)
    }, [id])

    return  (showUndo   ? (
                            <div className="undo-button-wrapper">
                              <Icon iconName={IconLibrary.CHECK} color='#3DAF35' sizeInPx='14'/>
                              <BasicButton content={"Undo"} className={"undo-button"} ariaLabel={'Undo action.'} onButtonClick={handleUndoClick} />
                            </div>
                          ) 
                        : (
                            <BasicButton content={buttonText} className={`${className}`} ariaLabel={ariaLabel} onButtonClick={handleButtonClick} isDisabled={isDisabled} isClassicCMSBlue={isClassicCMSBlue}/>
                          )
            );
};

export default AddToUndoButton